// import React from 'react';
// import { useField } from 'formik';

// export const FormikInput = ({ label, ...props }) => {
//   const [field, meta] = useField(props);
//   return (
//     <div className="flex flex-col gap-1 mb-4">
//       <label className="text-sm font-medium text-gray-400 ml-1">{label}</label>
//       <input
//         {...field}
//         {...props}
//         className={`bg-black/40 border ${
//           meta.touched && meta.error ? 'border-red-500/50' : 'border-white/10'
//         } rounded-lg px-4 py-3 text-white focus:outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500/50 transition-all placeholder-gray-600`}
//       />
//       {meta.touched && meta.error ? (
//         <div className="text-red-400 text-xs ml-1">{meta.error}</div>
//       ) : null}
//     </div>
//   );
// };

import React from 'react';
import { useField } from 'formik';
import { motion } from 'framer-motion';

export const FormikInput = ({ label, ...props }) => {
  const [field, meta] = useField(props);
  
  // Logical check for error state
  const hasError = meta.touched && meta.error;

  return (
    <div className="flex flex-col gap-1.5 mb-5 group">
      {/* Label updated to a more subtle, professional gray */}
      {label && (
        <label className="text-[11px] font-black uppercase tracking-[0.15em] text-gray-500 ml-1 transition-colors group-focus-within:text-orange-500">
          {label}
        </label>
      )}
      
      <div className="relative">
        <input
          {...field}
          {...props}
          className={`w-full bg-white/[0.03] border rounded-xl px-4 py-3.5 text-white transition-all duration-200 outline-none
            ${
              hasError 
                ? 'border-red-500/50 bg-red-500/5 focus:border-red-500' 
                : 'border-white/10 focus:border-orange-500/50 focus:bg-orange-500/[0.02] focus:ring-4 focus:ring-orange-500/10'
            } 
            placeholder:text-gray-700 font-medium`}
        />
        
        {/* Subtle glow effect on focus - Optional visual flair */}
        {!hasError && (
          <div className="absolute inset-0 rounded-xl pointer-events-none border border-orange-500/0 group-focus-within:border-orange-500/20 transition-all duration-300" />
        )}
      </div>

      {/* Error Message with transition-ready styling */}
      {hasError ? (
        <motion.div 
          initial={{ opacity: 0, x: -5 }}
          animate={{ opacity: 1, x: 0 }}
          className="text-red-400 text-[10px] font-bold uppercase tracking-wider ml-1 mt-1 flex items-center gap-1"
        >
          <span className="w-1 h-1 rounded-full bg-red-500" />
          {meta.error}
        </motion.div>
      ) : null}
    </div>
  );
};